import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionEventInfoRequest } from "../../info/event/actionEventInfo";
import { actionQuestAddQuest } from "../../info/quest/actionQuestInfo";
import { actionModalSwapLast } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionThemedEventStartResponse, TypeActionThemedEvent, } from "../actionThemedEvent";
export var epicThemedEventStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.StartRequest), switchMap(function (action) {
        var playerId = selectPlayerInfo(state$.value).playerId;
        return deps
            .netSend({
            id: CommandCode.ThemedEventStart,
            props: {
                difficulty: action.difficulty,
                eventId: action.eventId,
                playerId: playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionQuestAddQuest(res.quest),
                actionThemedEventStartResponse(res.eventId, res.quest, action.difficulty),
                actionEventInfoRequest(),
                actionModalSwapLast(IdModal.ThemedEvent),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventStart.ts
// module id = 2427
// module chunks = 3